// src/pages/Impersonate.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signInWithCustomToken } from 'firebase/auth';

// Public route hit in an incognito window via /impersonate?token=...
// Signs in with the admin-minted custom token, then lands where the
// customer lands. Does nothing for normal users (no token = no-op).
function Impersonate() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Signing in...');

  useEffect(() => {
    const run = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        if (!token) {
          setStatus('No token provided.');
          return;
        }
        await signInWithCustomToken(auth, token);
        // Strip the token from the URL, then route through /login so Login.js's
        // real redirect logic decides where this account lands — exactly what a
        // normal customer login does. Keeps impersonation faithful to production.
        window.history.replaceState({}, document.title, '/login');
        navigate('/login', { replace: true });
      } catch (err) {
        console.error('Impersonation sign-in failed:', err);
        setStatus('Sign-in failed. The link may have expired — generate a new one.');
      }
    };
    run();
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif' }}>
      <div style={{ textAlign: 'center', padding: 24, fontSize: 18, fontWeight: 700 }}>{status}</div>
    </div>
  );
}

export default Impersonate;
